module.exports = __webpack_public_path__ + "img/5.b398925e.jpg";